import { io } from 'socket.io-client';
import config from '../config/config';

let socket = null;

export const connectSocket = () => {
  if (!socket) {
    const serverOrigin = new URL(config.apiURL).origin;
    socket = io(serverOrigin, { transports: ['websocket', 'polling'] });
  }
  return socket;
};

export const getSocket = () => socket;

export const joinUniversityRoom = (universityId) => {
  if (socket) socket.emit('join_university_room', universityId);
};

export const joinTicketRoom = (ticketId) => {
  if (socket) socket.emit('join_ticket_room', ticketId);
};

export const leaveTicketRoom = (ticketId) => {
  if (socket) socket.emit('leave_ticket_room', ticketId);
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
